const WavesBotHeader = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1440 320"
      preserveAspectRatio="none"
      style={{
        display: 'block',
        width: '100%',
        height: '100px',
        marginTop: "-30px",
        padding: 0,
        lineHeight: 0,
        position: 'relative',
        zIndex: 1,
      }}
    >
<defs>
  {/* Dégradé fluide (blanc vers bleu foncé) */}
  <linearGradient id="fillGradient" x1="0%" y1="0%" x2="100%" y2="0%">
    <stop offset="0%" stopColor="white" />
    <stop offset="29%" stopColor="white" />
    <stop offset="71%" stopColor="#0d1b2a" />
    <stop offset="100%" stopColor="#0d1b2a" />
  </linearGradient>

  {/* Dégradé fluide inversé (bleu foncé vers blanc) */}
  <linearGradient id="strokeGradient" x1="0%" y1="0%" x2="100%" y2="0%">
    <stop offset="0%" stopColor="#0d1b2a" />
    <stop offset="29%" stopColor="#0d1b2a" />
    <stop offset="71%" stopColor="white" />
    <stop offset="100%" stopColor="white" />
  </linearGradient>
</defs>
      {/* BORDURE */}
      <path
        d="M0,256L80,245.3C160,235,320,213,480,
        218.7C640,224,800,256,960,256C1120,256,1280,224,1360,208L1440,192L1440,0L1360,0C1280,0,1120,0,960,0C800,0,640,0,480,0C320,0,160,0,80,0L0,0Z"
        fill="none"
        stroke="url(#strokeGradient)"
        strokeWidth="4"
      />

      {/* FOND */}
      <path
        fill="url(#fillGradient)"
        fillOpacity="1"
        d="M0,256L80,245.3C160,235,320,213,480,
        218.7C640,224,800,256,960,256C1120,256,1280,224,1360,208L1440,192L1440,0L1360,0C1280,0,1120,0,960,0C800,0,640,0,480,0C320,0,160,0,80,0L0,0Z"
      />
    </svg>
  );
};

export default WavesBotHeader;
